import { Col } from "antd";
import React from "react";

const MapItems = ({ item }) => {
  return (
    <>
      <div key={`${item.title}`} className="item">
        <Col lg={15} id="feature_box">
          <img src={item.imageURL} alt="amenities" />
          <h3>{item.title}</h3>
        </Col>
      </div>
    </>
  );
};

export default MapItems;
